import React, { useState } from 'react';
import { Dropdown } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../../context/ThemeContext';
import { KeyMetricSelectorProps, MetricOption } from './types';
import {
  StyledButton,
  DropdownContainer,
  OptionList,
  OptionItem,
  ButtonText,
} from './styles';

const KeyMetricSelector: React.FC<KeyMetricSelectorProps> = ({
  options = [],
  onSelectionChange,
  defaultValue,
  value: controlledValue,
}) => {
  const [selectedOption, setSelectedOption] = useState<string>(
    defaultValue || options?.[0]?.label || ''
  );
  const [isOpen, setIsOpen] = useState(false);
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };

  // Use controlled value if provided, otherwise use internal state
  const currentValue = controlledValue !== undefined 
    ? options.find(opt => opt.value === controlledValue)?.label || selectedOption
    : selectedOption;

  const handleOptionClick = (option: MetricOption) => {
    if (controlledValue === undefined) {
      setSelectedOption(option.label);
    }
    setIsOpen(false);
    onSelectionChange(option.value);
  };

  return (
    <Dropdown
      trigger={['click']}
      open={isOpen}
      onOpenChange={setIsOpen}
      dropdownRender={() => (
        <DropdownContainer theme={theme}>
          <OptionList>
            {options.map((option) => (
              <OptionItem
                key={option.value}
                isSelected={currentValue === option.label}
                theme={theme}
                onClick={() => handleOptionClick(option)}
              >
                {option.label}
              </OptionItem>
            ))}
          </OptionList>
        </DropdownContainer>
      )}
    >
      <StyledButton theme={theme} onClick={(e) => e.preventDefault()}>
        <ButtonText theme={theme}>{currentValue}</ButtonText>
        <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
      </StyledButton>
    </Dropdown>
  );
};

export default KeyMetricSelector;
